export const CHANGE_SUBCATEGORY_SELECTED_SUCCESS =
  "CHANGE_USER_SUBCATEGORY_SELECTED_SUCCESS";
